// Burger.js
import React from 'react'
import { StyledBurger } from './Burger.styled'

const Burger = ({ open, setOpen }) => {
  return (
    <StyledBurger
      id="hamburger-menu"
      open={open}
      onClick={() => setOpen(!open)}
    >
      <div />
      <div />
      <div />
    </StyledBurger>
  )
}

export default Burger
